import { render } from "./AlternativeAddressEdit.vue?vue&type=template&id=46476d69"
import script from "./AlternativeAddressEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AlternativeAddressEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/AlternativeAddressEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46476d69"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46476d69', __exports__)) {
    api.reload('46476d69', __exports__)
  }
  
  module.hot.accept("./AlternativeAddressEdit.vue?vue&type=template&id=46476d69", () => {
    api.rerender('46476d69', render)
  })

}


export default __exports__